/** Die Website hat zwei Ansichten: für Betriebe (Standard) und für Privatpersonen („HandVero Zuhause“, unter /privat). */
export const isPrivat = (pathname: string) => pathname === "/privat" || pathname.startsWith("/privat/");

/** Seiten, die für beide gelten (Anmeldung usw.). Dort bleibt die zuletzt gewählte Ansicht erhalten. */
const NEUTRAL = ["/login", "/anmelden", "/registrierung-gesendet", "/bestaetigen", "/passwort-vergessen", "/passwort-neu"];
const KEY = "hv_ansicht_web";

function remembered(): boolean {
  try {
    return sessionStorage.getItem(KEY) === "privat";
  } catch {
    return false;
  }
}

/** Ansicht für diese Adresse: /privat… ist privat, neutrale Seiten behalten die letzte Wahl, alles andere ist Betrieb. */
export function modeFor(pathname: string): boolean {
  const privat = isPrivat(pathname);
  const neutral = NEUTRAL.includes(pathname);
  try {
    if (!neutral) sessionStorage.setItem(KEY, privat ? "privat" : "betrieb");
  } catch {
    /* ohne Speicher gilt nur die Adresse */
  }
  return privat || (neutral && remembered());
}
